var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ranking-board"},[_c('div',{staticClass:"ranking-board-title"},[_vm._v("每日激活设备")]),_c('dv-scroll-ranking-board',{staticClass:"ranking-board-content",attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }